export const BRCurrencyFormatter = num => {
  const intlInstance = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })

  return intlInstance.format(num)
}
